import { KeyboardEvent, useCallback, useEffect, useLayoutEffect, useRef } from 'react';

/**
 * @deprecated
 */
export const useKeyPress = (keys: string[], callback: (event: KeyboardEvent) => void, node: Element | null = null) => {
    // implement the callback ref pattern
    const callbackRef = useRef(callback);
    useLayoutEffect(() => {
        callbackRef.current = callback;
    });

    // handle what happens on key press
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (!event.ctrlKey) {
                return;
            }
            // check if one of the key is part of the ones we want
            if (keys.some((key) => event.key === key)) {
                callbackRef.current(event);
            }
        },
        [keys],
    );

    useEffect(() => {
        // target is either the provided node or the document
        const targetNode = node ?? document;
        // attach the event listener
        targetNode && targetNode.addEventListener('keydown', handleKeyPress as any);

        // remove the event listener
        return () => targetNode && targetNode.removeEventListener('keydown', handleKeyPress as any);
    }, [handleKeyPress, node]);
};
